var $ = require("jquery");
window.jQuery = $; 
require("@fancyapps/fancybox");

import Vue from 'vue';
import app from './App';
import VueRouter from 'vue-router';
import { router } from './router.js';
import store from './store';

import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

Vue.use(VueRouter)
Vue.use(BootstrapVue);

Vue.config.productionTip = false

new Vue({
  render: h => h(app),
  router,
  store,
}).$mount('#app')
